import { siteMeta } from "@/mocks/chigua";
import useSeo from "@/hooks/useSeo";
import JsonLd from "@/components/chigua/JsonLd";
import { HeroHome } from "@/components/chigua/HeroHome";
import FeatureDeep from "@/components/chigua/FeatureDeep";
import ChannelGrid from "@/components/chigua/ChannelGrid";
import LatestStream from "@/components/chigua/LatestStream";
import HowWeVerify from "@/components/chigua/HowWeVerify";
import FaqSection from "@/components/chigua/FaqSection";

export default function Home() {
  useSeo({
    title: "今日吃瓜-内幕深扒与内幕真相的圈内时间线复盘",
    description:
      "今日吃瓜专注娱乐行业内幕深扒，以时间线复盘梳理圈内热点、内幕消息与内幕真相，覆盖影视、音乐、综艺与粉丝生态，一网看尽不用翻。",
    path: "/",
    keywords: "今日吃瓜,今日吃瓜内幕,今日吃瓜深扒,今日吃瓜内幕深扒,今日吃瓜内幕真相,圈内时间线复盘",
  });

  const schemas = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteMeta.brand,
      url: siteMeta.domain,
      description: siteMeta.description,
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "今日吃瓜-内幕深扒与内幕真相的圈内时间线复盘",
      description: siteMeta.description,
      url: `${siteMeta.domain}/`,
      inLanguage: "zh-CN",
      isPartOf: { "@type": "WebSite", name: siteMeta.brand, url: siteMeta.domain },
    },
  ];

  return (
    <>
      <JsonLd data={schemas} />
      <HeroHome />
      <FeatureDeep />
      <ChannelGrid />
      <LatestStream />
      <HowWeVerify />
      <FaqSection />
    </>
  );
}